import React from 'react';

export function Demo3Dashboard() {
  return <></>;
}
